import React, { useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import MediumBooking from "../medium/booking";
import { isOnboardingBookingRequest } from "../../utils/onboardingBooking";

/**
 * Wraps the booking page for medium route trees that otherwise have no /booking route
 * (pending approval, mid onboarding, mid integration). Those mediums may reach the
 * booking calendar through the Onboarding Session link only - anything else goes home.
 *
 * The decision is latched on first render because MediumBooking strips its deep link
 * query params from the URL a second after mount.
 */
export default function OnboardingBookingGuard() {
  const [searchParams] = useSearchParams();
  const [allowed] = useState(() => isOnboardingBookingRequest(searchParams));

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  return <MediumBooking />;
}
